import { useTranslation } from "react-i18next";
import { Divider, Form, Icon } from "semantic-ui-react";

import { Element } from "components/ReactScroll/index";
import { createFormHelper } from "lib/Form";
import "modules/LocationOverviewDashboard/components/Statuses/Statuses.scss";
import { STATUS_LABELS } from "modules/StatusListDashboard/components";

import type { STATUS_IDENTIFIERS } from "models";
import type { LocationDetailFormPayload } from "modules/LocationOverviewDashboard/hooks";

const FormHelper = createFormHelper<LocationDetailFormPayload>();

type StatusesProps = {
  tabId: string;
};

export const Statuses = ({ tabId }: StatusesProps) => {
  const { t } = useTranslation();

  const statuses = FormHelper.useWatch("statuses") ?? [];
  const sortedStatuses = statuses.map((status, index) => ({ status, index })).sort((a, b) => a.status.ordering - b.status.ordering);

  const getDefaultStatusLabel = (identifier: STATUS_IDENTIFIERS) => {
    const label = STATUS_LABELS[identifier];
    return label ? t(...label) : `${identifier}`;
  };

  return (
    <Element name={tabId} className="location-overview-section">
      <div className="section-title">
        <div>
          <Icon className="thumbtack" />
        </div>
        <span className="section-title-text">{t("v8_statuses", "Statuses")}</span>
      </div>

      <div className="LocationOverviewStatusesGrid">
        {sortedStatuses.map(({ status, index }) => (
          <Form.Field key={status.id}>
            <label>{getDefaultStatusLabel(status.identifier)}</label>
            <div className="status-name-input">
              <FormHelper.Field.ColorPicker name={`statuses.${index}.color`} formFieldProps={{ className: "status-color-field" }} />
              <FormHelper.Field.Input name={`statuses.${index}.name`} inputProps={{ placeholder: t("v8_name", "Name") }} />
            </div>
          </Form.Field>
        ))}
      </div>

      <Divider />
      <div className="location-overview-subheading">{t("v8_tablet", "Tablet")}</div>
      <Form.Field>
        <FormHelper.Field.Checkbox
          name="is_assigned_wo_status_change_notification_enabled"
          label={t("v8_notify_change_of_statuses_on_assigned_wo", "Notify Change of Statuses on Assigned WO")}
        />
      </Form.Field>
    </Element>
  );
};
